// extracted by mini-css-extract-plugin
export default {"root":"RfkZFw","TextOnlyMenuButtonNSkin":"vDnwi4","textOnlyMenuButtonNSkin":"vDnwi4","linkElement":"lY3Nwh","wrapper":"rBTT56","label":"foFAdY"};